import {Alert} from "@mui/material";
import React, {PropsWithChildren} from "react";

export const ErrorBox = ({children}: PropsWithChildren<{}>) => <Alert severity="error">{children}</Alert>;
export const WarningBox = ({children}: PropsWithChildren<{}>) => <Alert severity="warning">{children}</Alert>;
export const InfoBox = ({children}: PropsWithChildren<{}>) => <Alert severity="info">{children}</Alert>;
